export default __webpack_public_path__ + "media/pro/password protection-50754f6f.svg";